import React, { useState, useEffect, useRef } from "react";
import ApiClient from "../ApiClient";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { selectUser } from "src/stores/userSlice";
import { EditNotificationAction, selectNotification } from 'src/stores/notificationSlice';
import { notify } from "../utils/ToastUtils";
import { StatCardSkeleton, ListCardSkeleton } from "../components/PageSkeletonLoaders";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  TextField,
  Switch,
  Button,
  FormControlLabel,
  Tabs,
  Tab,
  Skeleton
} from "@mui/material";
import { X, Trash2, ImagePlus, Images, Image as ImageIcon, Check, Settings, ArrowLeft, ChevronLeft, ChevronRight, UserX, Home, Building2, UsersRound, Users, Calendar, ArrowRight, MoreVertical, CalendarDays, CalendarCheck, TrendingUp, PieChart, Activity } from "lucide-react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement } from "chart.js";
import { Bar, Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

import moment from "moment";

import NameLogo from "../images/NameLogo.png";
import team1 from "../images/team1.jpeg";
import team2 from "../images/team2.jpeg";
import team3 from "../images/team3.jpeg";
import team4 from "../images/team4.jpeg";
import team5 from "../images/team5.jpeg";
import team6 from "../images/team6.png";
import "../css/OurTeam.css";
import Card from "src/components/Card";
import TeamDirectory from "./TeamDirectory";
import UserAvatar from "src/components/UserAvatar";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
export const OurTeam = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const notification = useSelector(selectNotification);
  const [team, setTeam] = useState([]);
  const [carouselImages, setCarouselImages] = useState([]);
  const user = useSelector(selectUser);

  // New states for Unified Page
  const [activeTab, setActiveTab] = useState(0);
  const [availTab, setAvailTab] = useState("In Office");
  const [todayLeaveData, setTodayLeaveData] = useState(null);
  const [todayWfhData, setTodayWfhData] = useState(null);
  const [Events, setEvents] = useState([]);
  const [BirthDay, setBirthDay] = useState([]);
  const [attendanceTrend, setAttendanceTrend] = useState(null);

  // Carousel state
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);
  const [selectedImageId, setSelectedImageId] = useState(null);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [imageToDelete, setImageToDelete] = useState(null);
    // Autoplay and user interaction states
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const autoplayTimerRef = React.useRef(null);
  const activityTimeoutRef = React.useRef(null);
  
  // Swipe and Drag ref & state
  const swipeRef = useRef({ startX: 0, endX: 0, isDragging: false });
  const [isDragging, setIsDragging] = useState(false);
  const minSwipeDistance = 50;
  const AUTO_PLAY_INTERVAL = 2000; // 2 sec
  const RESUME_AFTER_IDLE = 20000; // 20 sec
  const getImageUrl = (img) => {
    if (img.isNewUpload) {
      return img.previewUrl;
    }
    return `${process.env.REACT_APP_PUBLIC_URL}/${img.IMG_PATH}`;
  };
  const getTeamMembers = async () => {
    try {
      const { data } = await ApiClient.get(
        `${process.env.REACT_APP_BASE_URL}/user/ourTeam`,
        { headers: { skipLoader: true } }
      );
      setTeam(data);
    } catch (error) {
      let errmsg = error?.response
        ? error?.response?.data?.message
          ? error?.response?.data?.message
          : `${error?.response?.status} - ${error?.response?.statusText}`
        : "Something went wrong. Please try again later";
      notify.error(errmsg);
    }
  };

  const getCarouselImages = async () => {
    try {
      const { data } = await ApiClient.get(
        `${process.env.REACT_APP_BASE_URL}/user/carouselImages`,
        { headers: { skipLoader: true } }
      );
      setCarouselImages(data);
    } catch (error) {
      console.error("Failed to load carousel images", error);
    }
  };

  const getTodayLeave = async () => {
    try {
      const { data } = await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/admin/getLeaveRecords`, {
        code: '',
        startDt: moment(new Date()).format('YYYY-MM-DD'),
        endDt: moment(new Date()).format('YYYY-MM-DD'),
      }, { headers: { skipLoader: true } });
      setTodayLeaveData(data);
    } catch (error) {
      setTodayLeaveData([]);
    }
  };

  const getTodayWFH = async () => {
    try {
      const { data } = await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/admin/getWfhRecords`, {
        code: '',
        startDt: moment(new Date()).format('YYYY-MM-DD'),
        endDt: moment(new Date()).format('YYYY-MM-DD'),
      }, { headers: { skipLoader: true } });
      setTodayWfhData(data);
    } catch (error) {
      setTodayWfhData([]);
    }
  };

  const getEvents = async () => {
    try {
      const alertsAndEvents = await ApiClient.get(`${process.env.REACT_APP_BASE_URL}/dashboard/getAlertsAndEvents`, { headers: { skipLoader: true } });
      setEvents(alertsAndEvents?.data?.filter((ele) => ele.TYPE == "Event") || []);
    } catch (error) {}
  };

  const getBirthday = async () => {
    try {
      const birthday = await ApiClient.get(`${process.env.REACT_APP_BASE_URL}/dashboard/todayBirthday`, { headers: { skipLoader: true } });
      setBirthDay(birthday.data || []);
    } catch (error) {}
  };

  const getAttendanceTrend = async () => {
    try {
      const fromDate = moment().subtract(6, 'days').format('YYYY-MM-DD');
      const toDate = moment().format('YYYY-MM-DD');
      const { data } = await ApiClient.get(`${process.env.REACT_APP_BASE_URL}/dashboard/attendanceTrend`, {
        params: { fromDate, toDate },
        headers: { skipLoader: true }
      });
      setAttendanceTrend(data);
    } catch (error) {
      setAttendanceTrend([]);
    }
  };

  const markAsRead = async () => {
    var unReadEvents = Events.filter((ele) => !ele?.IS_READ?.includes(user.emp_code));
    try {
      await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/dashboard/readAlertsOrEvents`, { Unread: unReadEvents, empcode: user.emp_code });
      var data = { ...notification, ['Events']: "No" };
      dispatch(EditNotificationAction(data));
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpcomingEventscontainers = () => {
      setTimeout(() => {
          const el = document.getElementById("upcomingEventsCartToShow");
          if (!el) return;

          el.scrollIntoView({
              behavior: "smooth",
              block: "center",
          });

          el.style.scrollMarginTop = "100px";
          el.style.transition = "box-shadow 250ms ease, transform 250ms ease";

          // Thin modern highlight
          el.style.boxShadow = "0 0 0 2px rgba(59, 130, 246, 0.45)";
          el.style.transform = "scale(1.01)";

          setTimeout(() => {
              el.style.boxShadow = "";
              el.style.transform = "";
          }, 1800);
      }, 100);
  };
  
  const param = useParams();
  
  useEffect(() => {
      if (!isLoading && param.component === "upcomingEvents") {
          handleUpcomingEventscontainers();
          if (Events.length > 0 && user) {
              var unread = Events.filter((ele) => !ele?.IS_READ?.includes(user.emp_code));
              if (unread.length > 0) {
                  markAsRead();
              }
          }
      }
  }, [param, Events, user, isLoading]);

  useEffect(() => {
    const fetchAllData = async () => {
      setIsLoading(true);
      await Promise.allSettled([
        getTeamMembers(),
        getCarouselImages(),
        getTodayLeave(),
        getTodayWFH(),
        getEvents(),
        getBirthday(),
        getAttendanceTrend()
      ]);
      setIsLoading(false);
    };
    fetchAllData();
  }, []);

  const defaultCarousel = [
    {
      ID: "default1",
      IMG_PATH: team1,
      isDefault: true,
      TITLE: "Q4 Annual Team Recognition Event",
      DESCRIPTION:
        "Celebrating 25% growth and individual excellence milestones.",
      BADGE: "FEATURED EVENT",
      EVENT_DATE: "2024-12-15",
      ACTIVE: "Yes",
    },
    {
      ID: "default2",
      IMG_PATH: team2,
      isDefault: true,
      TITLE: "Collaborative Design Workshop",
      DESCRIPTION:
        "Brainstorming and mapping user journeys for the next release.",
      BADGE: "WORKSHOP",
      EVENT_DATE: "2023-10-24",
      ACTIVE: "Yes",
    },
    {
      ID: "default3",
      IMG_PATH: team3,
      isDefault: true,
      TITLE: "Q3 Team Huddle, 2024",
      DESCRIPTION: "Showcasing our brilliant contributors and company culture.",
      BADGE: "TEAM HUDDLE",
      EVENT_DATE: "2024-09-10",
      ACTIVE: "Yes",
    },
    {
      ID: "default4",
      IMG_PATH: team4,
      isDefault: true,
      TITLE: "Product Strategy Huddle",
      DESCRIPTION: "Aligning goals and roadmap for the upcoming quarter.",
      BADGE: "HUDDLE",
      EVENT_DATE: "2024-07-05",
      ACTIVE: "Yes",
    },
    {
      ID: "default5",
      IMG_PATH: team5,
      isDefault: true,
      TITLE: "Technical Knowledge Sharing",
      DESCRIPTION: "Deep dive into system architecture and microservices.",
      BADGE: "TECH TALK",
      EVENT_DATE: "2024-05-18",
      ACTIVE: "Yes",
    },
    {
      ID: "default6",
      IMG_PATH: team6,
      isDefault: true,
      TITLE: "Outdoor Team Building",
      DESCRIPTION: "Strengthening communication and collaboration in nature.",
      BADGE: "TEAM BUILDING",
      EVENT_DATE: "2024-04-12",
      ACTIVE: "Yes",
    },
  ];

  // Prepare public slides array
  const slides =
    carouselImages.length > 0
      ? carouselImages.map((img) => ({
          ID: img.ID,
          IMG_PATH: `${process.env.REACT_APP_PUBLIC_URL}/${img.IMG_PATH}`,
          isDefault: false,
          TITLE: img.TITLE,
          DESCRIPTION: img.DESCRIPTION,
          BADGE: img.BADGE,
          EVENT_DATE: img.EVENT_DATE,
          ACTIVE: img.ACTIVE,
        }))
      : defaultCarousel;

  // Filter active ones for display in main public carousel
  const activeSlides = slides.filter((slide) => slide.ACTIVE !== "No");
  const displaySlides =
    activeSlides.length > 0 ? activeSlides : defaultCarousel;
  const currentSlide = displaySlides[currentSlideIndex] || displaySlides[0];

  // Carousel navigation handlers
  const handlePrevSlide = () => {
    handleUserInteraction();
    setCurrentSlideIndex((prev) =>
      prev === 0 ? displaySlides.length - 1 : prev - 1,
    );
  };

  const handleNextSlide = () => {
    handleUserInteraction();
    setCurrentSlideIndex((prev) =>
      prev === displaySlides.length - 1 ? 0 : prev + 1,
    );
  };

  // Resume auto play after 20 seconds of inactivity
  const handleUserInteraction = () => {
    setIsAutoPlaying(false);
    if (activityTimeoutRef.current) {
      clearTimeout(activityTimeoutRef.current);
    }
    activityTimeoutRef.current = setTimeout(() => {
      setIsAutoPlaying(true);
    }, RESUME_AFTER_IDLE);
  };

  // Autoplay effect
  useEffect(() => {
    if (isAutoPlaying) {
      autoplayTimerRef.current = setInterval(() => {
        setCurrentSlideIndex((prev) =>
          prev === displaySlides.length - 1 ? 0 : prev + 1
        );
      }, AUTO_PLAY_INTERVAL);
    }
    return () => {
      if (autoplayTimerRef.current) {
        clearInterval(autoplayTimerRef.current);
      }
    };
  }, [isAutoPlaying, displaySlides.length]);

  const handleStart = (e) => {
    handleUserInteraction();
    const clientX = e.type === "touchstart" ? e.targetTouches[0].clientX : e.clientX;
    swipeRef.current = {
      startX: clientX,
      endX: clientX,
      isDragging: true,
    };
    if (e.type === "mousedown") {
      setIsDragging(true);
    }
  };

  const handleMove = (e) => {
    if (!swipeRef.current.isDragging) return;
    const clientX = e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
    swipeRef.current.endX = clientX;
  };

  const handleEnd = () => {
    if (!swipeRef.current.isDragging) return;
    const { startX, endX } = swipeRef.current;
    swipeRef.current.isDragging = false;
    setIsDragging(false);

    const distance = startX - endX;
    if (distance > minSwipeDistance) handleNextSlide();
    if (distance < -minSwipeDistance) handlePrevSlide();
  };

  // Reset index if displaySlides size changes
  useEffect(() => {
    setCurrentSlideIndex(0);
  }, [displaySlides.length]);

  // Open Modal handler
  const handleOpenModal = () => {
    // Deep copy current dynamic images for editing
    setModalImages([...carouselImages]);
    setDeletedImageIds([]);
    setImageToDelete(null);
    if (carouselImages.length > 0) {
      setSelectedImageId(carouselImages[0].ID);
    } else {
      setSelectedImageId(null);
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    handleDiscardChanges();
  };

  // Modal file upload handler (Stages files locally)
  const handleModalUploadImage = (evt) => {
    const files = evt.target.files || evt.dataTransfer.files;
    if (!files.length) return;

    let newImages = [];
    const validFiles = Array.from(files).filter((file) => {
      if (file.size > 4 * 1024 * 1024) {
        notify.error(`File size cannot exceed 4MB: ${file.name}`);
        return false;
      }
      return true;
    });

    for (let i = 0; i < validFiles.length; i++) {
      const file = validFiles[i];
      const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      const previewUrl = URL.createObjectURL(file);

      newImages.push({
        ID: tempId,
        file: file,
        isNewUpload: true,
        previewUrl: previewUrl,
        IMG_PATH: previewUrl,
        TITLE: "",
        DESCRIPTION: "",
        BADGE: "",
        EVENT_DATE: null,
        ACTIVE: "Yes",
        CREATED_DATE: new Date(),
      });
    }

    if (newImages.length > 0) {
      setModalImages((prev) => [...prev, ...newImages]);
      setSelectedImageId(newImages[newImages.length - 1].ID);
    }
    // Allow selecting the same file again
    evt.target.value = null;
  };

  // Modal detail editing change handler
  const handleDetailChange = (field, value) => {
    setModalImages((prev) =>
      prev.map((img) => {
        if (img.ID === selectedImageId) {
          return { ...img, [field]: value };
        }
        return img;
      }),
    );
  };

  // Modal delete image handler (Staged vs Existing DB image)
  const handleDeleteImageInModal = (id) => {
    setImageToDelete(id);
  };

  const confirmDeleteImage = () => {
    const id = imageToDelete;
    const targetImg = modalImages.find((img) => img.ID === id);
    if (!targetImg) {
      setImageToDelete(null);
      return;
    }

    if (targetImg.isNewUpload) {
      if (targetImg.previewUrl) {
        URL.revokeObjectURL(targetImg.previewUrl);
      }
    } else {
      setDeletedImageIds((prev) => [...prev, id]);
    }

    const updated = modalImages.filter((img) => img.ID !== id);
    setModalImages(updated);

    if (selectedImageId === id) {
      if (updated.length > 0) {
        setSelectedImageId(updated[0].ID);
      } else {
        setSelectedImageId(null);
      }
    }
    setImageToDelete(null);
  };

  const cancelDeleteImage = () => {
    setImageToDelete(null);
  };

  // Drag and drop sorting handlers
  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, index) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === index) return;

    const updatedImages = [...modalImages];
    const draggedItem = updatedImages[draggedIndex];

    updatedImages.splice(draggedIndex, 1);
    updatedImages.splice(index, 0, draggedItem);

    setModalImages(updatedImages);
    setDraggedIndex(null);
  };

  // Save all changes (uploads + updates + deletes + reordering)
  const handleSaveChanges = async () => {
    setIsSaving(true);
    try {
      const formData = new FormData();

      // 1. Deletions
      formData.append("deletedIds", JSON.stringify(deletedImageIds));

      // 2. Updates & New Uploads
      const updates = [];
      const newImagesData = [];
      const reorderIds = modalImages.map((img) => img.ID);

      modalImages.forEach((img) => {
        if (img.isNewUpload) {
          newImagesData.push({
            tempId: img.ID,
            TITLE: img.TITLE,
            DESCRIPTION: img.DESCRIPTION,
            EVENT_DATE: img.EVENT_DATE,
            ACTIVE: img.ACTIVE || "Yes",
          });
          formData.append(img.ID, img.file);
        } else {
          updates.push({
            ID: img.ID,
            TITLE: img.TITLE,
            DESCRIPTION: img.DESCRIPTION,
            EVENT_DATE: img.EVENT_DATE,
            ACTIVE: img.ACTIVE || "Yes",
          });
        }
      });

      formData.append("updates", JSON.stringify(updates));
      formData.append("newImagesData", JSON.stringify(newImagesData));
      formData.append("reorderIds", JSON.stringify(reorderIds));

      await ApiClient.post(
        `${process.env.REACT_APP_BASE_URL}/user/syncCarouselImages`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      // Revoke temporary object URLs
      modalImages.forEach((img) => {
        if (img.isNewUpload && img.previewUrl) {
          URL.revokeObjectURL(img.previewUrl);
        }
      });

      notify.success("Gallery changes saved successfully");
      setDeletedImageIds([]);
      setIsModalOpen(false);
      getCarouselImages();
    } catch (error) {
      let errmsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to save gallery changes";
      notify.error(errmsg);
    } finally {
      setIsSaving(false);
    }
  };

  // Discard changes
  const handleDiscardChanges = () => {
    modalImages.forEach((img) => {
      if (img.isNewUpload && img.previewUrl) {
        URL.revokeObjectURL(img.previewUrl);
      }
    });
    setDeletedImageIds([]);
    setIsModalOpen(false);
    getCarouselImages();
  };

  let actualLeaveCount = 0;
  let actualWfhCount = 0;

  // Derive all members for the table
  const allMembersList = team.map(member => {
    const code = member.EMP_CODE || member.emp_code || "";
    const name = (member.EMP_NAME || member.name || "").trim().toLowerCase();

    const leaveMatch = (todayLeaveData || []).find(l => {
        const lc = l.EMP_CODE || l.emp_code || l.EMP_ID || "";
        const ln = (l.EMP_NAME || l.emp_name || "").trim().toLowerCase();
        return (code && lc === code) || (name && ln === name);
    });
    
    const wfhMatch = (todayWfhData || []).find(w => {
        const wc = w.EMP_CODE || w.emp_code || w.EMP_ID || "";
        const wn = (w.EMP_NAME || w.emp_name || "").trim().toLowerCase();
        return (code && wc === code) || (name && wn === name);
    });
    
    let type = 'In Office';
    let rawData = null;
    
    if (leaveMatch) { 
        type = 'On Leave'; 
        actualLeaveCount++; 
        rawData = leaveMatch;
    }
    else if (wfhMatch) { 
        type = 'WFH'; 
        actualWfhCount++; 
        rawData = wfhMatch;
    }

    const locationText = member.EMP_LOCATION ? `Office • ${member.EMP_LOCATION}` : (type === 'WFH' ? 'Home' : 'Office • Chennai');
    const checkInText = type === 'In Office' ? `09:00 AM` : null;

    return {
      name: member.EMP_NAME || member.name,
      designation: member.DESIGNATION || member.designation || member.Designation || '',
      type,
      location: type === 'On Leave' ? '-' : locationText,
      checkInTime: checkInText,
      rawData
    };
  }).sort((a, b) => a.name.localeCompare(b.name));

  const totalTeamMembers = team.length;
  const officeCount = Math.max(0, totalTeamMembers - actualLeaveCount - actualWfhCount);
  const totalAvailability = officeCount + actualWfhCount + actualLeaveCount;
  const officePercentage = totalAvailability > 0 ? ((officeCount / totalAvailability) * 100).toFixed(1) : 0;
  const wfhPercentage = totalAvailability > 0 ? ((actualWfhCount / totalAvailability) * 100).toFixed(1) : 0;
  const leavePercentage = totalAvailability > 0 ? ((actualLeaveCount / totalAvailability) * 100).toFixed(1) : 0;

  const filteredAvailabilityList = allMembersList.filter(m => {
    if (availTab === 'All') return true;
    return m.type === availTab;
  });

  const weeklyAttendanceData = {
    labels: attendanceTrend?.map(d => d.label) || [],
    datasets: [
      {
        label: 'In Office',
        data: attendanceTrend?.map(d => d.inOffice) || [],
        backgroundColor: '#3b82f6',
        borderRadius: 4,
        barThickness: 16,
      },
      {
        label: 'WFH',
        data: attendanceTrend?.map(d => d.wfh) || [],
        backgroundColor: '#22c55e',
        borderRadius: 4,
        barThickness: 16,
      },
      {
        label: 'On Leave',
        data: attendanceTrend?.map(d => d.absent) || [],
        backgroundColor: '#f97316',
        borderRadius: 4,
        barThickness: 16,
      }
    ],
  };

  const barChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    plugins: {
      tooltip: {
        backgroundColor: '#1e293b',
        titleFont: { size: 13, family: "'Inter', sans-serif" },
        bodyFont: { size: 12, family: "'Inter', sans-serif" },
        padding: 12,
        cornerRadius: 8,
      },
      legend: { display: false },
      datalabels: {
        display: (context) => context.dataset.data[context.dataIndex] > 0,
        anchor: 'end',
        align: 'end',
        offset: 2,
        color: '#64748b',
        font: { size: 9, weight: 'bold' }
      }
    },
    scales: {
      y: { beginAtZero: true, max: 100, grid: { display: false }, border: { display: false } },
      x: { grid: { display: false }, border: { display: false } }
    }
  };

  const doughnutData = {
    labels: ['In Office', 'Working From Home', 'On Leave'],
    datasets: [{
      data: [officeCount, actualWfhCount, actualLeaveCount],
      backgroundColor: ['#3b82f6', '#22c55e', '#f97316'],
      borderWidth: 0,
      cutout: '75%',
    }]
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: { display: false }
    }
  };

  const availabilityTabs = [
    { id: 'In Office', label: 'In Office', count: officeCount },
    { id: 'WFH', label: 'WFH', count: actualWfhCount },
    { id: 'On Leave', label: 'On Leave', count: actualLeaveCount },
  ];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const selectedImage = modalImages.find((img) => img.ID === selectedImageId);

  return (
    <>
    <div className="bg-transparent w-full h-full flex flex-col overflow-y-auto overflow-x-hidden">
      <div className="max-w-[1700px] mx-auto px-2 sm:px-4 py-0 sm:py-0 flex-1 w-full flex flex-col mb-0">
            {/* Tailwind Tabs */}
            <div className="sticky top-0 z-10 bg-[#f6f6f6] pb-3 -mx-2 sm:-mx-4 px-2 sm:px-4">
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="flex overflow-x-auto scrollbar-hide">
                <button
                  type="button"
                  onClick={() => handleTabChange(null, 0)}
                  className={`relative px-5 py-3 text-sm font-medium whitespace-nowrap transition-all duration-200 border-b-2 ${
                    activeTab === 0
                      ? "border-blue-600 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Overview
                </button>
                <button
                  type="button"
                  onClick={() => handleTabChange(null, 1)}
                  className={`relative px-5 py-3 text-sm font-medium whitespace-nowrap transition-all duration-200 border-b-2 ${
                    activeTab === 1
                      ? "border-blue-600 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Team
                </button>
                <button
                  type="button"
                  onClick={() => handleTabChange(null, 2)}
                  className={`relative px-5 py-3 text-sm font-medium whitespace-nowrap transition-all duration-200 border-b-2 ${
                    activeTab === 2
                      ? "border-blue-600 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Gallery
                </button>
              </div>
            </div>
          </div>

            {/* Tab 0: Overview */}
            {activeTab === 0 && (
              isLoading ? (
                <div className="flex flex-col gap-2 sm:gap-3 animation-fade-in mb-2 sm:mb-3">
                  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2 sm:gap-3">
                    <StatCardSkeleton />
                    <StatCardSkeleton />
                    <StatCardSkeleton />
                    <StatCardSkeleton />
                  </div>
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-3">
                    <ListCardSkeleton rows={5} />
                    <ListCardSkeleton rows={5} />
                  </div>
                </div>
              ) : (
              <div className="flex flex-col gap-2 sm:gap-3 animation-fade-in mb-2 sm:mb-3">
                {/* Metric Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2 sm:gap-3">
                    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-2xl bg-purple-50 text-purple-500 flex items-center justify-center shrink-0">
                            <UsersRound className="w-5 h-5" />
                        </div>
                        <div>
                            <h4 className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">Total Team Members</h4>
                            <div className="flex items-end gap-1.5">
                                <span className="text-xl font-bold text-slate-800 leading-none">{totalTeamMembers}</span>
                            </div>
                            <p className="text-[10px] font-medium text-slate-400 mt-1">All Time</p>
                        </div>
                    </div>
                    
                    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-2xl bg-blue-50 text-blue-500 flex items-center justify-center shrink-0">
                            <Building2 className="w-5 h-5" />
                        </div>
                        <div>
                            <h4 className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">In Office</h4>
                            <div className="flex items-end gap-1.5">
                                <span className="text-xl font-bold text-slate-800 leading-none">{officeCount}</span>
                            </div>
                            <p className="text-[10px] font-medium text-slate-400 mt-1">Today</p>
                        </div>
                    </div>

                    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-2xl bg-green-50 text-green-500 flex items-center justify-center shrink-0">
                            <Home className="w-5 h-5" />
                        </div>
                        <div>
                            <h4 className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">Working From Home</h4>
                            <div className="flex items-end gap-1.5">
                                <span className="text-xl font-bold text-slate-800 leading-none">{actualWfhCount}</span>
                            </div>
                            <p className="text-[10px] font-medium text-slate-400 mt-1">Today</p>
                        </div>
                    </div>

                    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-2xl bg-orange-50 text-orange-500 flex items-center justify-center shrink-0">
                            <CalendarCheck className="w-5 h-5" />
                        </div>
                        <div>
                            <h4 className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">On Leave</h4>
                            <div className="flex items-end gap-1.5">
                                <span className="text-xl font-bold text-slate-800 leading-none">{actualLeaveCount}</span>
                            </div>
                            <p className="text-[10px] font-medium text-slate-400 mt-1">Today</p>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-3">
                  {/* Today's Availability */}
                  <div className="flex flex-col shadow-sm border border-slate-200 rounded-2xl bg-white p-0 h-[440px]">
                      <div className="px-5 py-4 border-b border-slate-100 flex flex-wrap items-center justify-between gap-4">
                          <div className="flex items-center gap-3 shrink-0">
                            <div className="w-9 h-9 rounded-xl bg-blue-50 text-blue-500 flex items-center justify-center shrink-0">
                              <Activity className="w-5 h-5" />
                            </div>
                            <div className="flex flex-col">
                              <h4 className="font-bold text-slate-800 m-0 text-[15px] leading-tight">Today's Availability</h4>
                              <span className="text-[11px] font-medium text-slate-500 leading-tight mt-0.5">Real-time status of your team</span>
                            </div>
                          </div>
                          
                          {/* Filter Tabs */}
                          <div className="flex gap-2 overflow-x-auto scrollbar-hide justify-start min-w-[280px]">
                            {availabilityTabs.map(tab => (
                              <button 
                                key={tab.id}
                                onClick={() => setAvailTab(tab.id)}
                                className={`px-2.5 py-1 rounded-full text-[11px] font-bold whitespace-nowrap transition-colors border ${
                                  availTab === tab.id 
                                    ? 'bg-blue-50 text-blue-600 border-blue-200' 
                                    : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'
                                }`}
                              >
                                {tab.label} ({tab.count})
                              </button>
                            ))}
                          </div>
                      </div>
                      
                      <div className="flex-1 overflow-x-auto overflow-y-auto min-h-0">
                          {(availTab === 'On Leave' || availTab === 'WFH') ? (
                              <div className="flex flex-col gap-1 pr-2 p-2 custom-scrollbar">
                                {filteredAvailabilityList.length > 0 ? (
                                    filteredAvailabilityList?.map((ele, idx) => {
                                        const raw = ele.rawData || {};
                                        const status = raw.STATUS || raw.LEAVE_STATUS || "Pending";
                                        const days = Number(raw.NO_OF_DAYS || 1);
                                        const type = raw.LEAVE_TYPE || (availTab === 'WFH' ? 'Work From Home' : 'Vacation Leave');
                                        
                                        let dateText = "Today only";
                                        if (raw.START_DATE && raw.END_DATE) {
                                            if (raw.START_DATE === raw.END_DATE) {
                                                dateText = new Date(raw.START_DATE).toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'});
                                            } else {
                                                dateText = `${new Date(raw.START_DATE).toLocaleDateString('en-GB', {day: '2-digit', month: 'short'})} - ${new Date(raw.END_DATE).toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'})}`;
                                            }
                                        }

                                        const isApproved = status.toLowerCase() === 'approved' || status.toLowerCase() === 'accepted';
                                        return (
                                            <div key={idx} className="flex flex-col sm:flex-row sm:items-center justify-between p-2 border-b border-slate-100 hover:border-transparent hover:bg-slate-50 transition-colors gap-4">
                                                {/* Employee Details */}
                                                <div className="flex items-center gap-4 flex-[1.2] min-w-0">
                                                    <UserAvatar name={ele.name} size={38} className="shadow-sm font-bold" />
                                                    <div className="flex flex-col min-w-0">
                                                        <h4 className="text-[14px] font-bold text-slate-800 m-0 leading-tight truncate">{ele.name}</h4>
                                                        <p className="text-[12px] font-medium text-slate-500 m-0 leading-tight truncate mt-0.5">{type}</p>
                                                    </div>
                                                </div>
                                                
                                                {/* Duration */}
                                                <div className="flex items-center gap-4 flex-1 sm:border-l sm:border-slate-200 sm:pl-6 min-w-0">
                                                    <CalendarDays className="w-5 h-5 text-slate-400 shrink-0" />
                                                    <div className="flex flex-col min-w-0">
                                                        <span className="text-[11px] font-medium text-slate-500 leading-tight">Duration</span>
                                                        <span className="text-[12px] font-bold text-slate-800 leading-tight truncate">{dateText}</span>
                                                    </div>
                                                </div>

                                                {/* Total and Status */}
                                                <div className="flex items-center justify-between gap-4 flex-[0.8] sm:border-l sm:border-slate-200 sm:pl-6">
                                                    <div className="flex flex-col">
                                                        <span className="text-[11px] font-medium text-slate-500 leading-tight">Total</span>
                                                        <span className="text-[12px] font-bold text-slate-800 leading-tight whitespace-nowrap">{days === 0.5 ? "Half Day" : `${days} Day${days > 1 ? 's' : ''}`}</span>
                                                    </div>
                                                    
                                                    {user?.is_admin === "Yes" && 
                                                    <div className="ml-auto shrink-0">
                                                        <span className={`px-2 py-0.5 rounded-full text-[11px] font-bold border ${isApproved ? 'bg-green-50 text-green-700 border-green-200' : 'bg-orange-50 text-orange-600 border-orange-200'}`}>
                                                            {status}
                                                        </span>
                                                    </div>}
                                                </div>
                                            </div>
                                        )
                                    })
                                ) : (
                                    <div className="col-span-full flex flex-col items-center justify-center p-10 bg-gradient-to-b from-slate-50 to-white rounded-2xl border border-dashed border-slate-200 m-4 text-center">
                                        <div className="relative mb-4">
                                            <div className="w-16 h-16 rounded-2xl bg-blue-50 flex items-center justify-center shadow-inner transform rotate-3 transition-transform hover:rotate-0">
                                                <Users className="w-8 h-8 text-blue-400 stroke-[1.5]" />
                                            </div>
                                            <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white rounded-xl shadow-sm border border-slate-100 flex items-center justify-center transform -rotate-6">
                                                <span className="text-xs">🔍</span>
                                            </div>
                                        </div>
                                        <h4 className="text-[15px] font-bold text-slate-800 m-0 mb-1">No Members Found</h4>
                                        <p className="text-[13px] font-medium text-slate-500 m-0">
                                            {availTab === 'All' ? "We couldn't find any team members." : `No team members ${availTab === 'In Office' ? 'in the office' : availTab === 'On Leave' ? 'on leave' : availTab === 'WFH' ? 'on WFH' : availTab === 'Absent' ? 'absent' : 'matching this status'} today.`}
                                        </p>
                                    </div>
                                )}
                              </div>
                          ) : (
                              <table className="w-full text-left text-sm text-slate-600">
                                <thead className="text-[11px] font-bold text-slate-500 border-b border-slate-100 bg-slate-50 sticky top-0 z-10">
                                  <tr>
                                    <th className="px-5 py-2.5 font-medium">Employee</th>
                                    <th className="px-5 py-2.5 font-medium">Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {filteredAvailabilityList.length > 0 ? (
                                      filteredAvailabilityList.map((ele, idx) => (
                                          <tr key={idx} className="border-b border-slate-100 hover:border-transparent hover:bg-slate-50 transition-colors">
                                              <td className="px-5 py-2.5">
                                                  <div className="flex items-center gap-3">
                                                      <UserAvatar name={ele.name} size={36} className="shadow-sm" />
                                                      <div className="flex flex-col">
                                                          <h4 className="text-[13px] font-bold text-slate-800 m-0 leading-none">{ele.name}</h4>
                                                          <span className="text-[11px] font-medium text-slate-500 leading-none mt-1">{ele.designation}</span>
                                                      </div>
                                                  </div>
                                              </td>
                                              <td className="px-5 py-2.5">
                                                <div className="flex items-center">
                                                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold border whitespace-nowrap ${
                                                        ele.type === 'In Office' ? 'bg-green-50 text-green-700 border-green-200' :
                                                        ele.type === 'WFH' ? 'bg-blue-50 text-blue-700 border-blue-200' :
                                                        'bg-orange-50 text-orange-700 border-orange-200'
                                                    }`}>
                                                        {ele.type === 'In Office' ? 'Available' : ele.type}
                                                    </span>
                                                </div>
                                              </td>
                                          </tr>
                                      ))
                                  ) : (
                                      <tr>
                                        <td colSpan="3">
                                          <div className="flex flex-col items-center justify-center p-10 bg-gradient-to-b from-slate-50 to-white rounded-2xl border border-dashed border-slate-200 m-4 text-center">
                                              <div className="relative mb-4">
                                                  <div className="w-16 h-16 rounded-2xl bg-blue-50 flex items-center justify-center shadow-inner transform rotate-3 transition-transform hover:rotate-0">
                                                      <Users className="w-8 h-8 text-blue-400 stroke-[1.5]" />
                                                  </div>
                                                  <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white rounded-xl shadow-sm border border-slate-100 flex items-center justify-center transform -rotate-6">
                                                      <span className="text-xs">🔍</span>
                                                  </div>
                                              </div>
                                              <h4 className="text-[15px] font-bold text-slate-800 m-0 mb-1">No Members Found</h4>
                                              <p className="text-[13px] font-medium text-slate-500 m-0">
                                                  {availTab === 'All' ? "We couldn't find any team members." : `No team members ${availTab === 'In Office' ? 'in the office' : availTab === 'On Leave' ? 'on leave' : availTab === 'WFH' ? 'on WFH' : availTab === 'Absent' ? 'absent' : 'matching this status'} today.`}
                                              </p>
                                          </div>
                                        </td>
                                      </tr>
                                  )}
                                </tbody>
                              </table>
                          )}
                      </div>
                  </div>

                  {/* Upcoming Events */}
                  <div id="upcomingEventsCartToShow" className="flex flex-col shadow-sm border border-slate-200 rounded-2xl bg-white p-0 h-[440px] transition-all relative group">
                      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="w-9 h-9 rounded-xl bg-pink-50 text-pink-500 flex items-center justify-center shrink-0">
                              <CalendarDays className="w-5 h-5" />
                            </div>
                            <h4 className="font-bold text-slate-800 m-0 text-[15px]">Upcoming Events & Birthdays</h4>
                          </div>
                          <div className="flex items-center gap-4">
                              {notification?.Events === "Yes" && (
                                  <button onClick={() => markAsRead()} className="text-[13px] font-semibold text-blue-600 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-lg transition-colors">
                                      Mark As Read
                                  </button>
                              )}
                              {/* <button className="text-[13px] font-bold text-blue-600 hover:text-blue-700 flex items-center gap-1 transition-colors">
                                  View calendar <ArrowRight size={14} strokeWidth={2.5} />
                              </button> */}
                          </div>
                      </div>
                      
                      <div className="p-2 flex-1 overflow-y-auto min-h-0">
                          <div className="flex flex-col">
                              {Events?.length > 0 || BirthDay?.length > 0 ? (
                                  <>
                                      {Events?.map((ele, index) => {
                                          let eventDetails = null;
                                          try {
                                              eventDetails = typeof ele.EVENT_DETAILS === 'string' ? JSON.parse(ele.EVENT_DETAILS) : ele.EVENT_DETAILS;
                                          } catch (e) {}

                                          const title = eventDetails?.title || ele.DESCRIPTION;
                                          const eventDate = eventDetails?.event_date ? moment(eventDetails.event_date) : moment(ele.RAISED_DATE);
                                          const monthStr = eventDate.format('MMM');
                                          const dayStr = eventDate.format('DD');
                                          const weekdayStr = eventDate.format('ddd');
                                          
                                          let timeStr = "";
                                          if (eventDetails?.start_time && eventDetails?.end_time) {
                                              const start = moment(eventDetails.start_time, "HH:mm").format("hh:mm A");
                                              const end = moment(eventDetails.end_time, "HH:mm").format("hh:mm A");
                                              timeStr = `${start} - ${end}`;
                                          }

                                          const eventType = eventDetails?.event_type || 'Event';

                                          return (
                                          <div key={ele.REQUEST_ID} className="flex items-start gap-4 py-2 px-3 border-b border-slate-100 hover:border-transparent hover:bg-slate-50 transition-colors">
                                              <div className="flex flex-col items-center justify-center w-[48px] shrink-0">
                                                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">{monthStr}</span>
                                                  <span className="text-[20px] font-bold text-slate-800 leading-none">{dayStr}</span>
                                                  <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wider mt-1">{weekdayStr}</span>
                                              </div>
                                              <div className="flex flex-col justify-center flex-1 overflow-hidden">
                                                  <div className="flex items-center justify-between gap-2 mb-1">
                                                    <span className="text-[14px] font-bold text-slate-800 truncate" title={title}>{title}</span>
                                                    <span className="px-2 py-0.5 bg-purple-50 text-purple-600 border border-purple-200 rounded-md text-[10px] shrink-0 font-bold">{eventType}</span>
                                                  </div>
                                                  {timeStr && <span className="text-[11px] font-medium text-slate-500 mb-1">{timeStr}</span>}
                                                  {ele.DESCRIPTION && (
                                                    <div className="flex items-center gap-3 text-[11px] font-medium text-slate-500">
                                                      <span className="truncate" title={ele.DESCRIPTION}>{ele.DESCRIPTION}</span>
                                                    </div>
                                                  )}
                                              </div>
                                          </div>
                                          )
                                      })}
                                      {BirthDay?.map((ele) => {
                                          const rawDob = ele?.ORIGINAL_DOB || ele?.EMP_DATE_OF_BIRTH || "";
                                          const bdayMoment = rawDob ? moment(rawDob) : null;
                                          const monthStr = bdayMoment?.isValid() ? bdayMoment.format('MMM') : moment().format('MMM');
                                          const dayStr = bdayMoment?.isValid() ? bdayMoment.format('DD') : moment().format('DD');
                                          const thisYearBday = bdayMoment?.isValid() 
                                              ? moment().month(bdayMoment.month()).date(bdayMoment.date()) 
                                              : moment();
                                          const weekdayStr = thisYearBday.format('ddd');
                                          
                                          return (
                                              <div key={ele.EMP_CODE} className="flex items-start gap-4 py-2 px-3 border-b border-slate-100 hover:border-transparent hover:bg-slate-50 transition-colors">
                                                  <div className="flex flex-col items-center justify-center w-[48px] shrink-0">
                                                      <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">{monthStr}</span>
                                                      <span className="text-[20px] font-bold text-slate-800 leading-none">{dayStr}</span>
                                                      <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wider mt-1">{weekdayStr}</span>
                                                  </div>
                                                  <div className="flex flex-col justify-center flex-1 overflow-hidden">
                                                      <div className="flex items-center justify-between gap-2 mb-1">
                                                        <div className="flex items-center gap-2 truncate">
                                                          <span className="text-[14px] font-bold text-slate-800 truncate" title={`${ele.EMP_NAME}'s Birthday`}>{ele.EMP_NAME}'s Birthday</span>
                                                          <span className="text-sm shrink-0">🎂</span>
                                                        </div>
                                                        <span className="px-2 py-0.5 bg-yellow-50 text-yellow-700 border border-yellow-200 rounded-md text-[10px] shrink-0 font-bold">Birthday</span>
                                                      </div>
                                                      <span className="text-[11px] font-medium text-slate-500">Wish them a great year ahead!</span>
                                                  </div>
                                              </div>
                                          );
                                      })}
                                  </>
                              ) : (
                                  <div className="flex flex-col items-center justify-center p-10 bg-gradient-to-b from-slate-50 to-white rounded-2xl border border-dashed border-slate-200 m-2 mt-4 text-center">
                                      <div className="relative mb-4">
                                          <div className="w-16 h-16 rounded-2xl bg-pink-50 flex items-center justify-center shadow-inner transform -rotate-6 transition-transform hover:rotate-0">
                                              <CalendarDays className="w-8 h-8 text-pink-400 stroke-[1.5]" />
                                          </div>
                                          <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-white rounded-xl shadow-sm border border-slate-100 flex items-center justify-center transform rotate-6">
                                              <span className="text-xs">👋</span>
                                          </div>
                                      </div>
                                      <h4 className="text-[15px] font-bold text-slate-800 m-0 mb-1">It's quiet around here...</h4>
                                      <p className="text-[13px] font-medium text-slate-500 m-0">No upcoming events or birthdays right now.</p>
                                  </div>
                              )}
                          </div>
                      </div>
                  </div>
                </div>

                {/* Bottom Row Charts (2 Columns) */}
                {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-3">
                  <div className="flex flex-col shadow-sm border border-slate-200 rounded-2xl bg-white p-0 h-[380px]">
                    <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-xl bg-emerald-50 text-emerald-500 flex items-center justify-center shrink-0">
                          <TrendingUp className="w-5 h-5" />
                        </div>
                        <h4 className="font-bold text-slate-800 m-0 text-[15px]">Attendance Trend</h4>
                      </div>
                      <span className="px-2.5 py-1 bg-blue-50 text-blue-600 border border-blue-200 rounded-md text-[11px] font-bold">Last 7 Days</span>
                    </div>
                    <div className="flex flex-col flex-1 p-5 sm:p-6 min-h-0">
                      <div className="flex-1 relative min-h-0">
                        <Bar data={weeklyAttendanceData} options={barChartOptions} />
                      </div>
                    <div className="flex items-center justify-center gap-6 mt-6">
                      <div className="flex items-center gap-2 text-[11px] font-bold text-slate-700">
                        <span className="w-2.5 h-2.5 rounded-full bg-blue-500"></span> In Office
                      </div>
                      <div className="flex items-center gap-2 text-[11px] font-bold text-slate-700">
                        <span className="w-2.5 h-2.5 rounded-full bg-green-500"></span> WFH
                      </div>
                      <div className="flex items-center gap-2 text-[11px] font-bold text-slate-700">
                        <span className="w-2.5 h-2.5 rounded-full bg-orange-500"></span> On Leave
                      </div>
                    </div>
                  </div>
                  </div>
                  <div className="flex flex-col shadow-sm border border-slate-200 rounded-2xl bg-white p-0 relative h-[380px]">
                    <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-xl bg-amber-50 text-amber-500 flex items-center justify-center shrink-0">
                          <PieChart className="w-5 h-5" />
                        </div>
                        <h4 className="font-bold text-slate-800 m-0 text-[15px]">Availability Distribution</h4>
                      </div>
                      <span className="px-2.5 py-1 bg-purple-50 text-purple-600 border border-purple-200 rounded-md text-[11px] font-bold">Today</span>
                    </div>
                    <div className="flex flex-col flex-1 p-4 sm:p-6 min-h-0 justify-center overflow-hidden">
                      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 xl:gap-8 flex-1 relative w-full">
                      <div className="w-[180px] h-[180px] xl:w-[220px] xl:h-[220px] relative shrink-0">
                        <Doughnut data={doughnutData} options={doughnutOptions} />
                        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none text-center">
                          <span className="text-xl xl:text-2xl font-bold text-slate-800 leading-tight">{officePercentage}%</span>
                          <span className="text-[11px] xl:text-[12px] font-semibold text-slate-500">In Office</span>
                        </div>
                      </div>
                      
                      <div className="flex flex-col gap-3 xl:gap-4 ml-0 sm:ml-2 flex-1 w-full max-w-[240px] hidden sm:flex shrink-0 min-w-[160px]">
                        <div className="grid grid-cols-[110px_1fr] xl:grid-cols-[140px_1fr] gap-2 text-[11px] xl:text-[12px] font-bold items-center">
                          <div className="flex items-center gap-2 text-slate-700">
                            <span className="w-2.5 h-2.5 rounded-full bg-blue-500 shrink-0"></span>In Office
                          </div>
                          <div className="text-left text-slate-900 whitespace-nowrap">
                            {officeCount} <span className="text-slate-400 font-medium ml-1">({officePercentage}%)</span>
                          </div>
                        </div>
                        <div className="grid grid-cols-[140px_1fr] gap-2 text-[12px] font-bold items-center">
                          <div className="flex items-center gap-2 text-slate-700">
                            <span className="w-2.5 h-2.5 rounded-full bg-green-500 shrink-0"></span>Working From Home
                          </div>
                          <div className="text-left text-slate-900 whitespace-nowrap">
                            {actualWfhCount} <span className="text-slate-400 font-medium ml-1">({wfhPercentage}%)</span>
                          </div>
                        </div>
                        <div className="grid grid-cols-[140px_1fr] gap-2 text-[12px] font-bold items-center">
                          <div className="flex items-center gap-2 text-slate-700">
                            <span className="w-2.5 h-2.5 rounded-full bg-orange-500 shrink-0"></span>On Leave
                          </div>
                          <div className="text-left text-slate-900 whitespace-nowrap">
                            {actualLeaveCount} <span className="text-slate-400 font-medium ml-1">({leavePercentage}%)</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex flex-col gap-3 mt-4 sm:hidden">
                      <div className="flex items-center justify-between text-[11px] font-bold">
                        <div className="flex items-center gap-2 text-slate-700"><span className="w-2 h-2 rounded-full bg-blue-500"></span>In Office</div>
                        <div className="text-slate-900">{officeCount} <span className="text-slate-400 font-medium">({officePercentage}%)</span></div>
                      </div>
                      <div className="flex items-center justify-between text-[11px] font-bold">
                        <div className="flex items-center gap-2 text-slate-700"><span className="w-2 h-2 rounded-full bg-green-500"></span>WFH</div>
                        <div className="text-slate-900">{actualWfhCount} <span className="text-slate-400 font-medium">({wfhPercentage}%)</span></div>
                      </div>
                      <div className="flex items-center justify-between text-[11px] font-bold">
                        <div className="flex items-center gap-2 text-slate-700"><span className="w-2 h-2 rounded-full bg-orange-500"></span>On Leave</div>
                        <div className="text-slate-900">{actualLeaveCount} <span className="text-slate-400 font-medium">({leavePercentage}%)</span></div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div> */}

              </div>
              )
            )}

            {/* Tab 1: Directory */}
            {activeTab === 1 && (
              <TeamDirectory team={team || []} isLoading={isLoading} />
            )}

            {/* Tab 2: Culture */}
            {activeTab === 2 && (
              isLoading ? (
                <div className="mb-4 w-full animation-fade-in">
                   <div className="relative w-full overflow-hidden rounded-[2rem] shadow-sm border border-slate-200 h-[300px] md:h-[450px] lg:h-[600px] 2xl:h-[700px] bg-slate-50 p-2 sm:p-3 mt-4">
                     <Skeleton variant="rounded" width="100%" height="100%" sx={{ borderRadius: '1.5rem' }} />
                   </div>
                </div>
              ) : (
              <div className="mb-4 w-full animation-fade-in">
                {/* Header Section */}
                <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-2 mt-1 pt-1 mx-2 shrink-0 gap-4">
                  <div className="flex flex-col">
                    <h2 className="text-[20px] font-bold text-slate-900 m-0 leading-none">Gallery</h2>
                    <p className="text-[13px] text-slate-500 font-medium my-1">Capturing moments, celebrations, and milestones of our team.</p>
                  </div>
                  {user?.is_admin === "Yes" && (
                    <button
                      type="button"
                      className="flex items-center justify-center gap-1.5 bg-blue-600 text-white px-3 h-8 rounded-lg hover:bg-blue-700 hover:-translate-y-0.5 transition-all shadow-[0_4px_12px_rgba(37,99,235,0.2)] font-semibold text-[12px]"
                      onClick={handleOpenModal}
                    >
                      <ImageIcon size={14} /> Manage Gallery
                    </button>
                  )}
                </div>

              {displaySlides.length > 0 ? (
                  <div className="w-full flex flex-col items-center pb-2">
                      <div className="w-full bg-white rounded-2xl border border-[#E8EDF5] shadow-[0_4px_12px_rgba(15,23,42,0.06)] overflow-hidden p-2">
                        <div 
                          className="relative w-full h-[calc(100vh-270px)] min-h-[400px] max-h-[800px] rounded-[14px] overflow-hidden group bg-slate-900"
                          onTouchStart={handleStart}
                          onTouchMove={handleMove}
                          onTouchEnd={handleEnd}
                          onMouseDown={handleStart}
                          onMouseMove={handleMove}
                          onMouseUp={handleEnd}
                          onMouseLeave={() => {
                            if (swipeRef.current.isDragging) {
                              handleEnd();
                            }
                          }}
                          style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
                        >
                           <img src={currentSlide.IMG_PATH} alt={currentSlide.TITLE} className="w-full h-full object-cover select-none transition-transform duration-700 ease-out group-hover:scale-[1.02]" draggable="false" />
                           
                           {/* Navigation Arrows */}
                           <button 
                             type="button"
                             onClick={(e) => { e.stopPropagation(); handlePrevSlide(); }} 
                             onMouseDown={(e) => e.stopPropagation()}
                             onMouseUp={(e) => e.stopPropagation()}
                             onTouchStart={(e) => e.stopPropagation()}
                             onTouchEnd={(e) => e.stopPropagation()}
                             className="absolute left-6 top-1/2 -translate-y-1/2 w-11 h-11 bg-black/40 backdrop-blur-md rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 text-white hover:scale-110 z-20 hover:bg-black/60 shadow-lg cursor-pointer"
                           >
                             <ChevronLeft size={24} strokeWidth={1.5} />
                           </button>
                           <button 
                             type="button"
                             onClick={(e) => { e.stopPropagation(); handleNextSlide(); }} 
                             onMouseDown={(e) => e.stopPropagation()}
                             onMouseUp={(e) => e.stopPropagation()}
                             onTouchStart={(e) => e.stopPropagation()}
                             onTouchEnd={(e) => e.stopPropagation()}
                             className="absolute right-6 top-1/2 -translate-y-1/2 w-11 h-11 bg-black/40 backdrop-blur-md rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 text-white hover:scale-110 z-20 hover:bg-black/60 shadow-lg cursor-pointer"
                           >
                             <ChevronRight size={24} strokeWidth={1.5} />
                           </button>

                           {/* Overlay Text */}
                           {(currentSlide.EVENT_DATE || currentSlide.TITLE || currentSlide.DESCRIPTION) && (
                             <div className="absolute inset-x-0 bottom-0 pt-20 pb-4 px-4 bg-gradient-to-t from-black/80 via-black/30 to-transparent transition-all duration-300 flex flex-col justify-end z-10 select-none pointer-events-none">
                                <div className="max-w-3xl backdrop-blur-md bg-white/10 p-3 rounded-xl border border-white/10 shadow-lg translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 delay-100">
                                  {currentSlide.EVENT_DATE && (
                                     <div className="flex items-center gap-1.5 text-blue-200 text-[11px] font-medium mb-1">
                                        <CalendarDays size={12} />
                                        <span>{moment(currentSlide.EVENT_DATE).format("MMM DD, YYYY")}</span>
                                     </div>
                                  )}
                                  {currentSlide.TITLE && (
                                    <h3 className="text-[16px] font-bold mb-1 text-white leading-tight drop-shadow-md">{currentSlide.TITLE}</h3>
                                  )}
                                  {currentSlide.DESCRIPTION && (
                                    <p className="text-slate-200 text-[11px] leading-relaxed opacity-90 drop-shadow-md">{currentSlide.DESCRIPTION}</p>
                                  )}
                                </div>
                             </div>
                           )}

                           {/* Pagination (Option 1) */}
                           <div className="absolute bottom-6 right-8 text-white px-3 py-1.5 rounded-full text-[12px] font-bold z-20 shadow-sm pointer-events-none select-none tracking-widest backdrop-blur-md bg-black/40 border border-white/10">
                              {String(currentSlideIndex + 1).padStart(2, '0')} / {String(displaySlides.length).padStart(2, '0')}
                           </div>
                        </div>
                      </div>

                      {/* Dots Indicator (Outside) */}
                      <div className="flex justify-center items-center pt-3 pb-1 gap-2 w-full shrink-0">
                        {displaySlides.map((_, idx) => (
                           <button 
                             key={idx}
                             type="button"
                             onClick={(e) => { e.stopPropagation(); handleUserInteraction(); setCurrentSlideIndex(idx); }}
                             onMouseDown={(e) => e.stopPropagation()}
                             onMouseUp={(e) => e.stopPropagation()}
                             onTouchStart={(e) => e.stopPropagation()}
                             onTouchEnd={(e) => e.stopPropagation()}
                             className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${idx === currentSlideIndex ? 'w-8 bg-blue-600' : 'w-2 bg-slate-300 hover:bg-slate-400'}`}
                           />
                        ))}
                      </div>
                  </div>
              ) : (
                <div className="bg-white rounded-[24px] border border-slate-100 flex flex-col items-center justify-center py-10 px-4 shadow-sm w-full">
                  <div className="relative w-36 h-36 mb-2">
                    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M100 130L40 100V160L100 190L160 160V100L100 130Z" fill="#FDE6D5"/>
                      <path d="M100 130L40 100L100 70L160 100L100 130Z" fill="#FEEFE5"/>
                      <path d="M100 70V100L160 130V100L100 70Z" fill="#FCD3B6"/>
                      <path d="M40 100V70L100 40L160 70V100L100 70L40 100Z" fill="#FFF"/>
                      <path d="M100 70L40 100V70L100 40V70Z" fill="#FEEFE5"/>
                      <path d="M160 70V100L100 70V40L160 70Z" fill="#FCD3B6"/>
                      <rect x="75" y="30" width="50" height="60" rx="4" fill="#F1F5F9" transform="rotate(-15 100 60)"/>
                      <path d="M85 70L95 55L105 70L115 60L125 70" stroke="#CBD5E1" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-15 100 60)"/>
                      <circle cx="110" cy="50" r="4" fill="#CBD5E1" transform="rotate(-15 100 60)"/>
                      <path d="M30 120 Q50 90 70 110" stroke="#FCD3B6" strokeWidth="4" strokeLinecap="round" fill="none"/>
                      <circle cx="160" cy="140" r="10" fill="#FEEFE5"/>
                      <circle cx="40" cy="160" r="6" fill="#FEEFE5"/>
                      <circle cx="150" cy="60" r="8" fill="#FEEFE5"/>
                      <path d="M140 160 Q160 150 170 170" stroke="#FCD3B6" strokeWidth="4" strokeLinecap="round" fill="none"/>
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-slate-800">No images in the gallery yet</h3>
                </div>
              )}

              </div>
              )
            )}
          </div>

      </div>

      {/* Manage Team Gallery Modal */}
      <Modal
        open={isModalOpen}
        onClose={(e, reason) => {
          if (isSaving) return;
          handleCloseModal();
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "1100px",
            height: "90vh",
            bgcolor: "#F5F5F7",
            borderRadius: "24px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
            border: "1px solid #DADDE2",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <div
            className="flex justify-between items-center"
            style={{
              padding: "20px 24px",
              borderBottom: "1px solid #E4E4E7",
              background: "#FFFFFF",
              position: "sticky",
              top: 0,
              zIndex: 20,
              flexShrink: 0,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                fontSize: "19px",
                color: "#111827",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Images
                style={{
                  width: "24px",
                  height: "24px",
                  color: "#111827",
                }}
              />
              Manage Team Gallery
            </Typography>

            <IconButton
              onClick={handleCloseModal}
              disabled={isSaving}
              sx={{
                background: "#F3F4F6",
                border: "1px solid #E5E7EB",
                width: "33px",
                height: "33px",
                "&:hover": {
                  background: "#E5E7EB",
                },
              }}
            >
              <X size={20} />
            </IconButton>
          </div>

          {/* BODY */}
          <div
            style={{
              flex: 1,
              overflow: "hidden",
              minHeight: 0,
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1.7fr 0.9fr",
                height: "100%",
                minHeight: 0,
                overflow: "hidden",
              }}
            >
              {/* LEFT SECTION */}
              <div
                style={{
                  padding: "24px",
                  borderRight: "1px solid #E5E7EB",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  minHeight: 0,
                }}
              >
                {/* Carousel Order */}
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: 700,
                        letterSpacing: "0.5px",
                        color: "#111827",
                      }}
                    >
                      CAROUSEL ORDER
                    </div>

                    <div
                      style={{
                        fontSize: "11px",
                        color: "#6B7280",
                        marginTop: "2px",
                      }}
                    >
                      Drag thumbnails to reorder public sequence
                    </div>
                  </div>

                  <span
                    style={{
                      background: "#2563eb",
                      color: "#FFF",
                      padding: "5px 12px",
                      borderRadius: "999px",
                      fontSize: "11px",
                      fontWeight: 700,
                    }}
                  >
                    {modalImages.filter((img) => img.ACTIVE !== "No").length}{" "}
                    ACTIVE
                  </span>
                </div>

                {/* Delete Confirmation Banner */}

                {imageToDelete && (
                  <div
                    style={{
                      background: "#FEE2E2",
                      border: "1px solid #F87171",
                      borderRadius: "12px",
                      padding: "10px 14px",
                      marginBottom: "16px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#991B1B",
                        fontWeight: 500,
                      }}
                    >
                      Are you sure you want to delete this image?
                    </div>

                    <div style={{ display: "flex", gap: "10px" }}>
                      {/* Cancel */}
                      <div
                        title="Cancel"
                        onClick={!isSaving ? cancelDeleteImage : undefined}
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          border: "1px solid #D1D5DB",
                          background: "#FFFFFF",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: isSaving ? "not-allowed" : "pointer",
                          transition: "all 0.2s ease",
                          opacity: isSaving ? 0.5 : 1,
                        }}
                      >
                        <X size={14} color="#6B7280" />
                      </div>

                      {/* Confirm Delete */}
                      <div
                        title="Delete"
                        onClick={!isSaving ? confirmDeleteImage : undefined}
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          border: "1px solid #FCA5A5",
                          background: "#FEF2F2",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: isSaving ? "not-allowed" : "pointer",
                          transition: "all 0.2s ease",
                          opacity: isSaving ? 0.5 : 1,
                        }}
                      >
                        <Check size={14} color="#DC2626" />
                      </div>
                    </div>
                  </div>
                )}

                {/* Upload Card */}
                <label
                  htmlFor="modal-upload-input"
                  className="flex items-center justify-center"
                  style={{
                    background: "#FAFAFA",
                    border: "2px dashed #D4D4D8",
                    borderRadius: "16px",
                    minHeight: "92px",
                    cursor: isSaving ? "not-allowed" : "pointer",
                    pointerEvents: isSaving ? "none" : "auto",
                    opacity: isSaving ? 0.6 : 1,
                    transition: "0.2s",
                    padding: "20px",
                    marginBottom: "16px",
                    gap: "14px",
                    flexShrink: 0,
                  }}
                >
                  <div
                    className="flex items-center justify-center"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      background: "#E4E4E7",
                      flexShrink: 0,
                    }}
                  >
                    <ImagePlus
                      style={{
                        width: "20px",
                        height: "20px",
                        color: "#18181B",
                      }}
                    />
                  </div>

                  <div>
                    <div
                      style={{
                        fontSize: "17px",
                        fontWeight: 600,
                        color: "#18181B",
                        lineHeight: 1.2,
                      }}
                    >
                      Add New Gallery Image
                    </div>

                    <div
                      style={{
                        fontSize: "11px",
                        color: "#71717A",
                        marginTop: "4px",
                        letterSpacing: "0.2px",
                      }}
                    >
                      1920×1080px recommended • Max 4MB
                    </div>
                  </div>

                  <input
                    type="file"
                    id="modal-upload-input"
                    hidden
                    multiple
                    accept="image/*"
                    onChange={handleModalUploadImage}
                    disabled={isSaving}
                  />
                </label>

                {/* ONLY THIS SECTION SCROLLS */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, 132px)",
                    gap: "14px",

                    overflowY: "auto",

                    paddingRight: "4px",

                    flex: 1,
                    minHeight: 0,

                    alignContent: "start",
                    justifyContent: "start",
                  }}
                >
                  {modalImages.map((img, index) => {
                    const isSelected = selectedImageId === img.ID;

                    return (
                      <div
                        key={img.ID}
                        draggable={!isSaving}
                        onDragStart={(e) => {
                          if (!isSaving) handleDragStart(e, index);
                        }}
                        onDragOver={handleDragOver}
                        onDrop={(e) => {
                          if (!isSaving) handleDrop(e, index);
                        }}
                        onClick={() => setSelectedImageId(img.ID)}
                        style={{
                          width: "132px",
                          height: "150px",

                          borderRadius: "14px",
                          overflow: "hidden",
                          cursor: "grab",
                          background: "#FFF",

                          border: isSelected
                            ? "2px solid #18181B"
                            : "1px solid #E5E7EB",

                          transition: "0.2s",

                          boxShadow: isSelected
                            ? "0 4px 14px rgba(0,0,0,0.12)"
                            : "none",
                        }}
                      >
                        <img
                          src={getImageUrl(img)}
                          alt=""
                          style={{
                            width: "100%",
                            height: "92px",
                            objectFit: "cover",
                          }}
                        />

                        <div
                          style={{
                            padding: "8px",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: 600,
                              color: "#4B5563",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {img.TITLE || `Image ${index + 1}`}
                          </div>

                          <div
                            style={{
                              fontSize: "10px",
                              fontWeight: 700,
                              color: "#9CA3AF",
                              marginTop: "2px",
                              textTransform: "uppercase",
                            }}
                          >
                            Position #{index + 1}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* RIGHT SECTION */}
              <div
                style={{
                  background: "#FFFFFF",
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  overflow: "hidden",
                  minHeight: 0,
                }}
              >
                {/* Header (Right section) */}
                <div
                  className="flex justify-between items-center"
                  style={{
                    padding: "10px 20px",
                    borderBottom: "1px solid #E5E7EB",
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      fontSize: "18px",
                      fontWeight: 500,
                      color: "#111827",
                    }}
                  >
                    Edit Image Details
                  </div>

                  {selectedImage && (
                    <Button
                      color="error"
                      variant="text"
                      disabled={isSaving || imageToDelete === selectedImage.ID}
                      startIcon={<Trash2 size={16} />}
                      onClick={() => handleDeleteImageInModal(selectedImage.ID)}
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                      }}
                    >
                      Delete
                    </Button>
                  )}
                </div>

                {/* ONLY THIS SECTION SCROLLS */}
                <div
                  style={{
                    padding: "20px",
                    overflowY: "auto",
                    flex: 1,
                    minHeight: 0,
                  }}
                >
                  {selectedImage ? (
                    <>
                      {/* Preview */}
                      <div
                        style={{
                          border: "1px solid #E5E7EB",
                          borderRadius: "14px",
                          overflow: "hidden",
                          marginBottom: "18px",
                          flexShrink: 0,
                        }}
                      >
                        <img
                          src={getImageUrl(selectedImage)}
                          alt="Preview"
                          style={{
                            width: "100%",
                            height: "180px",
                            objectFit: "cover",
                          }}
                        />
                      </div>

                      {/* Form Fields */}
                      <div className="mb-2">
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: 600,
                            color: "#374151",
                            marginBottom: "8px",
                          }}
                        >
                          Image Title
                        </div>

                        <TextField
                          fullWidth
                          disabled={isSaving}
                          placeholder="Enter image title"
                          value={selectedImage.TITLE || ""}
                          onChange={(e) =>
                            handleDetailChange("TITLE", e.target.value)
                          }
                          size="small"
                          className="bg-slate-50"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                            },
                          }}
                        />
                      </div>

                      <div className="mb-2">
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: 600,
                            color: "#374151",
                            marginBottom: "8px",
                          }}
                        >
                          Description / Alt Text
                        </div>

                        <TextField
                          fullWidth
                          disabled={isSaving}
                          multiline
                          rows={4}
                          placeholder="Write image description..."
                          value={selectedImage.DESCRIPTION || ""}
                          onChange={(e) =>
                            handleDetailChange("DESCRIPTION", e.target.value)
                          }
                          className="bg-slate-50"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                            },
                          }}
                        />
                      </div>

                      <div className="mb-2">
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: 600,
                            color: "#374151",
                            marginBottom: "8px",
                          }}
                        >
                          Event Date
                        </div>

                        <TextField
                          fullWidth
                          disabled={isSaving}
                          size="small"
                          type="date"
                          value={
                            selectedImage.EVENT_DATE
                              ? moment(selectedImage.EVENT_DATE).format(
                                  "YYYY-MM-DD",
                                )
                              : ""
                          }
                          onChange={(e) =>
                            handleDetailChange("EVENT_DATE", e.target.value)
                          }
                          className="bg-slate-50"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                            },
                          }}
                        />
                      </div>

                      <div className="mb-0">
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: 600,
                            color: "#374151",
                            marginBottom: "0px",
                          }}
                        >
                          Visibility
                        </div>

                        <FormControlLabel
                          control={
                            <Switch
                              disabled={isSaving}
                              checked={selectedImage.ACTIVE !== "No"}
                              onChange={(e) =>
                                handleDetailChange(
                                  "ACTIVE",
                                  e.target.checked ? "Yes" : "No",
                                )
                              }
                            />
                          }
                          label="Active in Carousel"
                        />
                      </div>
                    </>
                  ) : (
                    <div className="h-full flex flex-col justify-center items-center">
                      <Images
                        style={{
                          width: "52px",
                          height: "52px",
                          color: "#9CA3AF",
                          marginBottom: "12px",
                        }}
                      />

                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#6B7280",
                        }}
                      >
                        Select an image to edit details
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <div
            className="flex justify-end items-center"
            style={{
              padding: "20px 24px",
              borderTop: "1px solid #E5E7EB",
              background: "#FFFFFF",
              position: "sticky",
              bottom: 0,
              zIndex: 20,
              flexShrink: 0,
            }}
          >
            <div className="flex gap-2">
              <Button
                variant="outlined"
                onClick={handleDiscardChanges}
                disabled={isSaving}
                sx={{
                  borderRadius: "8px",
                  borderColor: "#D1D5DB",
                  color: "#111827",
                  fontSize: "14px",
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Discard Changes
              </Button>

              <Button
                variant="contained"
                onClick={handleSaveChanges}
                disabled={isSaving}
                sx={{
                  borderRadius: "8px",
                  background: "#2563EB",
                  color: "#FFFFFF",
                  fontWeight: 700,
                  fontSize: "14px",
                  textTransform: "none",
                  fontSize: "15px",
                  boxShadow: "none",
                  "&:hover": {
                    background: "#1D4ED8",
                    boxShadow: "none",
                  },
                }}
              >
                {isSaving ? "Saving..." : "Save & Publish Gallery"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};
